import { useGridSelector } from "../../utils/index.js";
import { useGridApiContext } from "../../utils/useGridApiContext.js";
import { useGridRootProps } from "../../utils/useGridRootProps.js";
import { gridExpandedRowCountSelector } from "../filter/index.js";
import { gridRowCountSelector, gridRowsLoadingSelector } from "../rows/index.js";
import { gridPinnedRowsCountSelector } from "../rows/gridRowsSelector.js";
/**
 * Uses the grid state to determine which overlay to display.
 * Returns the active overlay type and the active loading overlay variant.
 */ export var useGridOverlays = function() {
    var apiRef = useGridApiContext();
    var rootProps = useGridRootProps();
    var totalRowCount = useGridSelector(apiRef, gridRowCountSelector);
    var visibleRowCount = useGridSelector(apiRef, gridExpandedRowCountSelector);
    var pinnedRowsCount = useGridSelector(apiRef, gridPinnedRowsCountSelector);
    var noRows = totalRowCount === 0 && pinnedRowsCount === 0;
    var loading = useGridSelector(apiRef, gridRowsLoadingSelector);
    var showNoRowsOverlay = !loading && noRows;
    var showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    var overlayType = null;
    var loadingOverlayVariant = null;
    if (showNoRowsOverlay) {
        overlayType = 'noRowsOverlay';
    }
    if (showNoResultsOverlay) {
        overlayType = 'noResultsOverlay';
    }
    if (loading) {
        var _rootProps_slotProps_loadingOverlay, _rootProps_slotProps;
        overlayType = 'loadingOverlay';
        loadingOverlayVariant = ((_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : (_rootProps_slotProps_loadingOverlay = _rootProps_slotProps.loadingOverlay) === null || _rootProps_slotProps_loadingOverlay === void 0 ? void 0 : _rootProps_slotProps_loadingOverlay[noRows ? 'noRowsVariant' : 'variant']) || null;
    }
    return {
        overlayType: overlayType,
        loadingOverlayVariant: loadingOverlayVariant
    };
};
